import app from '@/main'

async function userReportAbuse ({ userId, reasonId, source, messageId = null }) {
  return await app.wsp.sendRequest({
    data: {
      userId: userId,
      reasonId: reasonId,
      source: source, // "chat", "profile"
      messageId: messageId
    },
    method: 'user.reportAbuse'
  })
}

export default userReportAbuse